import PhoneGreenIcon from './icons/PhoneGreen.svg';
import NaviIcon from './icons/Navi.svg';
import NaviBlueIcon from './icons/NaviBlue.svg';
import EventIcon from './icons/Event.svg';
import EventGrayIcon from './icons/EventGray.svg';
import ArrowLeftIcon from './icons/ArrowLeft.svg';
import AlertIcon from './icons/Alert.svg';
import System_Alert_blue from './icons/System.Alert.blue.png';
import NotificationAlertIcon from './icons/notification-alert.png';
import ServiceAlertIcon from './icons/service-alert.png';

export default {
  PhoneGreenIcon,
  NaviIcon,
  NaviBlueIcon,
  EventIcon,
  EventGrayIcon,
  ArrowLeftIcon,
  AlertIcon,
  System_Alert_blue,
  NotificationAlertIcon,
  ServiceAlertIcon,
};

export { default as PhoneIcon } from './icons/Phone.svg';
// export { default as PhoneGreenIcon } from './icons/PhoneGreen.svg';
// export { default as NaviIcon } from './icons/Navi.svg';
export { default as NaviBlueIcon } from './icons/NaviBlue.svg';
export { default as EventIcon } from './icons/Event.svg';
export { default as EventGrayIcon } from './icons/EventGray.svg';
export { default as ArrowLeftIcon } from './icons/ArrowLeft.svg';
export { default as AlertIcon } from './icons/Alert.svg';
